import {Controller} from "stimulus"

export default class extends Controller {

    static targets = [
        "text",
    ]

    initialize() {

        const content = this.textTarget
        const elements = document.querySelectorAll('.logo__item')

        elements.forEach( element => {
            element.addEventListener('mouseover', ()=>{
                const text = element.getAttribute('data-text')
                content.textContent = text
                content.classList.add('is-active')
            })
            element.addEventListener("mouseout", ()=>{
                content.classList.remove('is-active')
            })
        })

    }

}
